import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { SchoolsPageComponent } from './schools.page';
import { SchoolDetailViewPageModule } from './view/view.module';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: SchoolsPageComponent,
    path: ''
  },
  {
    loadChildren: () => SchoolDetailViewPageModule,
    path: ':schoolNumber'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class SchoolsPageRoutingModule {}
